export default {"src":"/_next/static/media/hassle-free.e0d92468.svg","height":25,"width":25};